<form class="user-password-form" [formGroup]="form" (ngSubmit)="submit()">
  <label for="newPassword" translate>company.user.password-popup.password.label</label>
  <div class="vox-input-group vox-input-group_dense">
    <vox-password-input formControlName="newPassword" [language]="language">
    </vox-password-input>
  </div>
  <label for="confirmPassword" translate>company.user.password-popup.confirm-password.label</label>
  <div class="vox-input-group vox-input-group_dense" [ngClass]="{
    'vox-input-group_valid': form.valid,
    'vox-input-group_invalid': isConfirmationErrorVisible
    }">
    <input class="vox-text-field"
      type="password"
      id="confirmPassword"
      formControlName="confirmPassword"
      [placeholder]="'company.user.password-popup.confirm-password.placeholder' | translate" />
    <i *ngIf="form.valid"
      class="vox-text-field__icon"
      [ngClass]="{
      'vox-text-field__icon_valid icon-small-check': form.valid,
      'vox-text-field__icon_invalid icon-small-alert': isConfirmationErrorVisible
      }">
    </i>
    <span class="vox-input-group__error-message" translate>company.user.password-popup.no-match</span>
  </div>
  <div class="submit-container">
    <button class="vox-btn vox-btn-secondary"
      [disabled]="form.pristine || form.invalid && form.dirty"
      [ladda]="loading"
      data-spinner-color="grey"
      data-style="zoom-in"
      type="submit">
      <span translate>{{submitLabel}}</span>
    </button>
  </div>
</form>
